import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { afterHook } from '@next-adapter/generators/actions/lifecycle-hook-emissions/after-hook.js'
import { beforeHook } from '@next-adapter/generators/actions/lifecycle-hook-emissions/before-hook.js'
import { lifecycleHookImport } from '@next-adapter/generators/actions/lifecycle-hook-emissions/lifecycle-hook-import.js'
import { renderGenDeleteBulkContentRenderer } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-delete-bulk-content.js'

export function genDeleteBulkContent(ctx: EntityCtx): string {
  return renderGenDeleteBulkContentRenderer({
    kind: 'renderGenDeleteBulkContentServerActionTemplate',
    props: {
      ctxTableVar: ctx.tableVar,
      ctxCacheInvalidationFn: ctx.cacheInvalidationFn,
      ctxCamelPlural: ctx.camelPlural,
      lifecycleHookImport: lifecycleHookImport(),
      ctxSingular: ctx.Singular,
      ctxPlural: ctx.Plural,
      ctxPluralText: ctx.plural,
      beforeHook: beforeHook('beforeDelete', 'lifecycleContext'),
      afterHook: afterHook(
        'afterDelete',
        renderGenDeleteBulkContentRenderer({ kind: 'renderGenDeleteBulkContentTemplate' })
      )
    }
  })
}
